import {
  BenefitAdmissionDetail,
  CompanyBenefit,
} from 'types/generatedSchemaTypes';

export const collectIdentifiers = (
  admissionDetails: Array<BenefitAdmissionDetail | null> | null | undefined,
  customerEmail?: string | null
): string[] => {
  const ids = new Set<string>();

  admissionDetails?.forEach((detail) => {
    if (detail?.admission?.type === 'MANUALLY_ADDED') {
      if (customerEmail) ids.add(customerEmail);
      return;
    }

    detail?.attributes?.forEach((attr) => {
      if (attr?.verificationSubjectId) {
        ids.add(attr.verificationSubjectId);
      }
    });
  });

  return [...ids];
};

export const getVerifiedEmail = (
  admissionDetails: Array<BenefitAdmissionDetail | null> | null | undefined,
  contactEmail?: string | null
): string | undefined => {
  return collectIdentifiers(admissionDetails, contactEmail).find(
    (id) => id !== contactEmail
  );
};

export const getBenefitsForEmail = (
  benefits: CompanyBenefit[] | undefined,
  email: string
): CompanyBenefit[] => {
  if (!benefits) return [];
  return benefits.filter((benefit) => {
    const details = benefit.customerMemberMetadata?.admissionDetails;
    return details?.some((detail) =>
      detail?.attributes?.some((attr) => attr?.verificationSubjectId === email)
    );
  });
};
